<template>
  <div>
    <div class="flex justify-between items-center">
      <h1 class="text-lg font-bold" v-if="this.practice">
        {{this.practice.title}}
      </h1>

      <button
        class="mob-btn mob-btn--red"
        @click="showFinishModal()"
      >
        Finalizar
      </button>
      <MobBaseModal 
        ref="mobFinishModal"
        modal-id="modal-finish"
        title="Finalizar práctica"
        body-text="Realmente deseas finalizar la práctica?"
        :show-button1="true"
        :show-button2="true"
        button1-text="Aceptar"
        button2-text="Cancelar"
        :button1-callback="acceptFinishModal"
        :button2-callback="cancelFinishModal"
      />   
    </div>    

    <div class="border rounded-lg mt-4">
      <MobSteps 
        class="border-b" 
        :items="practiceSteps" 
        :allowNavigation="true" 
        @goBack="goBack" 
        @goForward="goForward" 
        :onlyBack="onlyBack"
      />
      <div class="border-t p-7"  v-if="practiceExercise">
        <ExerciseItem 
          ref="exerciseModule"
          :exercise="practiceExercise"
          :noCheck="false"
          :viewSolution="true"
          :showHint="true"
          :originId="this.practiceId"
          :origin="'practiceDiag'"
          :allowCorrection="false"
          @nextQuestion="nextQuestion"
          :lastExercise="this.lastExercise"
          @goToResults="goToResults"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { MobSteps } from "@/views/V2/components";
import mathJaxRender from "@/Utils/mathjax-render.js";
import ExerciseItem from "../components/ExerciseItem.vue";
import {enrollToPractice, getExercises, getPractice} from "@/services/practices.service";
import {getPermitNextQuestion, getQuestion} from "@/services/questions.service";
import { MobBaseModal } from "@/views/V2/components";

export default {
  name: "PracticeDetail",
  components: {
    MobSteps,
    ExerciseItem,
    MobBaseModal
  },
  props: {
    practicePropId: String,
    skipIfFinished: Boolean,
    resultsOnTemplate: Boolean
  },
  data() {
    return {
      practiceExerciseId: null,
      practiceExercise: {},
      practiceSteps: [],
      practice: {},
      practiceId: null,
      exercises: [],
      lastExercise: false,
      onlyBack: true,
    };
  },
  computed: {
    course() {
      return this.$store.state.course.current;
    },
  },
  methods: {
    goBack() {
      let indexQuestionActive =  this.exercises.findIndex(question => question.id === this.practiceExerciseId);

      if (indexQuestionActive === 0) {
        return;
      }
      this.nextQuestion(this.practiceExerciseId, false, true);
    },
    goToResults(){
      // /course/:id/diagnosticTest/:practiceId/results
      if (this.resultsOnTemplate) {
        this.$emit("showResults");
      } else  this.$router.push(`${this.practiceId}/results`);
    },
    showFinishModal() {
      this.$refs.mobFinishModal.showModal();
    },
    acceptFinishModal() {
      this.$refs.mobFinishModal.closeModal();
      this.$refs.exerciseModule.finishQuestionnaire();
    },
    cancelFinishModal() {
      this.$refs.mobFinishModal.closeModal();
    },
    goForward() {
      let indexQuestionActive =  this.exercises.findIndex(question => question.id === this.practiceExerciseId);

      if (indexQuestionActive > this.exercises.length - 1) {
        return;
      }
      this.nextQuestion(this.practiceExerciseId, true, false);
    },
    async verifyPermitNextQuestion(practiceExerciseId) {
      let indexQuestionActivenext = this.exercises.findIndex(question => question.id === practiceExerciseId) + 1;
      this.onlyBack = true;
      let permitForward = await getPermitNextQuestion( this.exercises[indexQuestionActivenext].id, 'practiceDiag', this.practiceId, this.course.id);
      if (permitForward.length > 0) {
        this.onlyBack = false;
      }
    },
    async nextQuestion(questionId, plus = true, goback = false) {
      let sum = plus ? 1 : goback? -1 : 0;
      let indexQuestionActive =  this.exercises.findIndex(question => question.id === questionId) + sum;
      this.lastExercise = false;
      
      if (indexQuestionActive > this.exercises.length - 1) {
        return;
      }

      this.practiceSteps = [];
      for (let exercisesIndex in this.exercises) {
        let exercise = this.exercises[exercisesIndex];
        if (exercisesIndex == indexQuestionActive) {
          this.practiceSteps.push({state: "active"})
          this.practiceExerciseId = exercise.id;
        } else {
          this.practiceSteps.push({state: "pending"})
        }
      }

      if (indexQuestionActive > this.exercises.length - 2) {
        this.lastExercise = true;
      } else {
        this.verifyPermitNextQuestion(this.practiceExerciseId);
      }

      if (this.practiceExerciseId) {
        this.practiceExercise = await getQuestion(this.practiceExerciseId);
        mathJaxRender();
      }
    },

    async fillExercises() {
      let loader = this.$loading.show({});
      this.exercises = await getExercises(this.practiceId);

      if ( this.exercises.length > 0) {
        this.practiceSteps = [];
        const indexFirstExercisNoAnswered = this.exercises.findIndex(exercise => !exercise.answered);
        this.nextQuestion( this.exercises[indexFirstExercisNoAnswered >= 0 ? indexFirstExercisNoAnswered : 0].id, false);
      }

      loader.hide();
    }
  },

  async mounted() {
    if (this.practicePropId) {
      this.practiceId = this.practicePropId;
    } else {
      this.practiceId = this.$route.params.practiceId;
    }
    if (this.practiceId) {
      this.practice = await getPractice(this.practiceId);
      let userPractice = await enrollToPractice(this.practiceId, this.$route.params.id);

      if(userPractice.finished && this.skipIfFinished) {
        this.goToResults()
      }

      await this.fillExercises();
    }
    mathJaxRender();
  },
  beforeMount() {
    (function () {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-AMS_HTML";
      document.getElementsByTagName("head")[0].appendChild(script);
    })();
  }
};
</script>
